// TODO: CONVERT TO TYPESCRIPT
import React from 'react'

export default function SearchResultAction (props) {
  return (
    <div className='search-result-action'>
      {props.children}
      <i className='fas fa-chevron-right' />
    </div>
  )
}
